module.exports = __webpack_public_path__ + "static/media/facebook-icon.15fdb8ef.svg";